<script setup lang="ts">
const { playlist } = storeToRefs(useAudioStore())
</script>

<template>
  <section
    v-if="playlist?.length"
    class="relative md:mt-10 flex h-full w-full pt-16 flex-col items-center justify-start overflow-hidden md:max-w-[70%] bg-darkest md:bg-darker"
  >
    <ol
      class="h-full w-full overflow-y-auto p-8 md:pr-8 md:pl-0 pt-6 [mask-image:linear-gradient(to_bottom,black_calc(100%-8rem),transparent)] md:mt-20 md:pb-32"
    >
      <UAudioPlayerPlaylistItem
        v-for="track in playlist"
        :key="track.id"
        :track="track"
      />
    </ol>
  </section>
  <h2 v-else class="font-light text-white">
    Vi fant ingen lydspor dessverre. Ta gjerne kontakt med oss om du
    skulle ønske det fantes, eller om dette virker som en feil!
  </h2>
</template>
